import React from "react";
import PropTypes from "prop-types";
import ImageLibpixel from "./image-libpixel.js";
import styled from "styled-components";

const Wrapper = styled.div`
  width: fit-content;
  max-width: 90%;
  margin: 80px auto;
  text-align: center;
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 811px) {
    flex-direction: column-reverse;
  }
`;
const QuoteContainer = styled.div`
  flex: 1;
  position: relative;
  font-family: Poppins, sans-serif;
  margin-top: 40px;
`;
const QuoteFrom = styled.span`
  font-weight: normal;
  font-size: 14px;
  display: block;
  margin: 10px 0 7px 0;
  color: #f15e4e;
  text-align: right;
  padding-right: 60px;
`;
const Img = styled(ImageLibpixel)`
  width: 200px;
  height: 200px;
  margin-left: 40px;
  object-fit: cover;
  border-radius: 100%;
`;
const Text = styled.div`
  font-size: ${(props) =>
    props.content && props.content.length > 140 ? "16px" : "32px"};
  font-weight: 500;
  p {
    line-height: inherit !important;
  }
`;
const Emphasis = styled.em`
  font-size: 82px;
  font-style: normal;
  font-weight: bold;
  color: #f15e4e;
  position: absolute;
  line-height: 100px;
  bottom: -65px;
  right: -50px;
  font-family: "Helvetica, sans-serif";
  @media (max-width: 811px) {
    right: -25px;
  }
  @media (max-width: 600px) {
    right: -5px;
  }
  &:first-child {
    right: auto;
    bottom: auto;
    left: -50px;
    top: -50px;
    margin-top: 0;
    @media (max-width: 811px) {
      left: -25px;
    }
    @media (max-width: 600px) {
      left: -5px;
    }
  }
`;

const CustomQuote = ({ content, title, img }) => {
  return (
    <>
      {content !== "null" ? (
        <Wrapper>
          <QuoteContainer>
            <Emphasis>“</Emphasis>
            <Text
              content={content}
              dangerouslySetInnerHTML={{ __html: content }}
            ></Text>
            <Emphasis>&#x201D;</Emphasis>
            {title && <QuoteFrom>{title}</QuoteFrom>}
          </QuoteContainer>
          {img && <Img src={img} width="200" height="200" />}
        </Wrapper>
      ) : undefined}
    </>
  );
};

CustomQuote.propTypes = {
  content: PropTypes.string,
  title: PropTypes.string,
  img: PropTypes.string,
};

CustomQuote.defaultProps = {
  content: undefined,
  title: undefined,
  img: undefined,
};

export default CustomQuote;
